import React, { useEffect, useRef, useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";

import { format } from "date-fns";

import FASTable from "../../../../../components/Tables/FASTable";
import { FiMenu } from "react-icons/fi";
import FASChart from "../../../../../components/Charts/FASChart";
import {
  SaleBook,
  SaleParty,
  SalesDashboard,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Sale/SaleSlice";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import FASDroupdownFilterBox from "../../../../../components/FilterBox/FASFilter/FASDropDownFilter";
import FASFilter from "../../../../../components/FilterBox/FASFilter/FASFilter";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export const ProductionGroupWise = () => {
  const dispatch = useDispatch();

  const { Colourdata, mainFilterData, DataMain } = useSelector(
    (state) => state.ClientLogin,
  );

  const { SaleBookdata, SalePartydata, SalesDashboarddata } = useSelector(
    (state) => state.SaleSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  const FinancialYear = Cookies.get("FinancialYear");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(SaleBook({ Firm, Year: YearId }));
    dispatch(SaleParty({ Firm, Year: YearId }));
    dispatch(FilterMain({ Firm, Year: YearId }));
    dispatch(
      SalesDashboard({
        Firm,
        Year: YearId,
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      }),
    );
  }, [dispatch, Firm, YearId, startDate, endDate]);

  const [filters, setFilters] = useState({
    month: [],
    saleBook: [],
    productionGroup: [],
    saleParty: [],
  });
  const [search, setSearch] = useState({
    month: "",
    saleBook: "",
    productionGroup: "",
    saleParty: "",
  });

  const [selectedMonth, setSelectedMonth] = useState([]);
  const [selectedMonthId, setSelectedMonthId] = useState([]);

  const [selectedSaleBook, setSelectedSaleBook] = useState([]);
  const [selectedSaleBookId, setSelectedSaleBookId] = useState([]);

  const [selectedProductionGroup, setSelectedProductionGroup] = useState([]);
  const [selectedProductionGroupId, setSelectedProductionGroupId] = useState(
    [],
  );
  const [selectedSaleParty, setSelectedSaleParty] = useState([]);
  const [selectedSalePartyId, setSelectedSalePartyId] = useState([]);
  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.month,
    })) || [];
  const saleBookList =
    SaleBookdata?.BookName?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];
  const salePartyList =
    SalePartydata?.BookName?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  const productionList =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const summaryData = {
    totalSaleAmount: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.NetAmount || 0,
    ),
    totalQuantitySold: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.Finishmeter || 0,
    ),
    averageSaleAmount: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.AvgAmt || 0,
    ),
  };
  const [activeTable, setActiveTable] = useState("Production");

  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const ProductionGroupSaleRow = () => {
    return (
      SalesDashboarddata?.ProdDtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const PartyWiseSaleRow = () => {
    return (
      SalesDashboarddata?.PartyDtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const ItemWiseSaleAmountRow = () => {
    return (
      SalesDashboarddata?.ItemDtl?.map((item, index) => ({
        // srNumber: index + 1,
        ...item,
      })) || []
    );
  };

  const ProductionGroupSaleColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Production Group Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: " NetAmount",
      key: "NetAmount",
      format: "true",
      align: "right",
    },
  ];

  const partyWiseColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Amount",
      key: "NetAmount",
      format: "true",
      align: "right",
    },
  ];
  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const alreadySelected = prev[type]?.includes(item.value);

      return {
        ...prev,
        [type]: alreadySelected ? [] : [item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    setFilters((prev) => ({
      ...prev,
      [type]: items?.[0]?.value ? [items[0].value] : [],
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const itemWiseColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Amount",
      key: "NetAmount",
      format: "true",
      align: "right",
    },
  ];
  const applyFilter = async () => {
    setIsFilterLoading(true);

    try {
      await dispatch(
        SalesDashboard({
          Firm,
          Year: YearId,
          selectePdGroupdIds: filters.productionGroup?.toString(),
          selecteBookdIds: filters.saleBook?.toString(),
          selectSalepartyIds: filters.saleParty?.toString() || "",
          selectmonthname: filters.month?.toString(),
          selectestartdate: safeFormat(startDate),
          selectenddate: safeFormat(endDate),
        }),
      );
    } finally {
      setIsFilterLoading(false);
    }
  };

  const applyFilter1 = async () => {
    setIsFilterLoading(true);

    try {
      await dispatch(
        SalesDashboard({
          Firm,
          Year: YearId,
          selectePdGroupdIds: selectedProductionGroupId?.toString() || "",
          selecteBookdIds: selectedSaleBookId?.toString() || "",
          selectSalepartyIds: selectedSalePartyId?.toString() || "",
          selectmonthname: selectedMonth?.toString() || "",
          selectestartdate: safeFormat(startDate),
          selectenddate: safeFormat(endDate),
        }),
      );
    } finally {
      setIsFilterLoading(false);
    }
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
      }`,
    borderLeft: `6px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
      }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };
  const isLoading =
    !SaleBookdata || !SalePartydata || !SalesDashboarddata || !mainFilterData;

  if (isLoading || isFilterLoading) {
    return <Loader />;
  }
  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* ✅ MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* ✅ OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Month */}
            <FASFilter
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            {/* Sale Books */}
            <FASFilter
              title="Sale Books"
              items={saleBookList}
              search={search.saleBook}
              setSearch={(val) => handleSearch("saleBook", val)}
              selectedItems={filters.saleBook}
              toggleItem={(item) => toggleItem("saleBook", item)}
              selectAll={() => selectAll("saleBook", saleBookList)}
            />

            {/* Production Groups */}
            <FASFilter
              title="Production Groups"
              items={productionList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() => selectAll("productionGroup", productionList)}
            />

            {/* Sale Party */}
            <FASFilter
              title="Sale Party"
              items={salePartyList}
              search={search.saleParty}
              setSearch={(val) => handleSearch("saleParty", val)}
              selectedItems={filters.saleParty}
              toggleItem={(item) => toggleItem("saleParty", item)}
              selectAll={() => selectAll("saleParty", salePartyList)}
            />

            {/* Apply Button */}
            <Button
              onClick={() => {
                applyFilter();
                handleClose();
              }}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4 align-items-start">
        {/* ✅ RIGHT SIDE */}
        <Col xl={12} lg={12} md={12}>
          {/* 🔹 SUMMARY BOXES */}
          <Row className="g-3">
            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.totalSaleAmount}</h4>
                <h6 style={titleStyle}>Total Sale Amount</h6>
              </div>
            </Col>

            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.totalQuantitySold}</h4>
                <h6 style={titleStyle}>Total Quantity Sold</h6>
              </div>
            </Col>

            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.averageSaleAmount}</h4>
                <h6 style={titleStyle}>Average Sale Amount</h6>
              </div>
            </Col>
          </Row>

          <div
            className="d-none d-lg-block"
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              padding: "12px",
              borderRadius: "12px",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
              border: `1px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
                }`,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <Row className="g-3 align-items-end">
              {/* Month */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Month"
                  data={monthList}
                  selectedValue={selectedMonth}
                  setSelectedValue={setSelectedMonth}
                  selectedId={selectedMonthId}
                  setSelectedId={setSelectedMonthId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Sale Book */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Books"
                  data={saleBookList}
                  selectedValue={selectedSaleBook}
                  setSelectedValue={setSelectedSaleBook}
                  selectedId={selectedSaleBookId}
                  setSelectedId={setSelectedSaleBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Production */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Production Groups"
                  data={productionList}
                  selectedValue={selectedProductionGroup}
                  setSelectedValue={setSelectedProductionGroup}
                  selectedId={selectedProductionGroupId}
                  setSelectedId={setSelectedProductionGroupId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Party */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Party"
                  data={salePartyList}
                  selectedValue={selectedSaleParty}
                  setSelectedValue={setSelectedSaleParty}
                  selectedId={selectedSalePartyId}
                  setSelectedId={setSelectedSalePartyId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* Apply Button */}
              <Col xl={12} lg={12} md={12} sm={12}>
                <Button
                  onClick={applyFilter1}
                  style={{
                    width: "100%",
                    height: "44px",
                    borderRadius: "12px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    border: "none",
                    fontWeight: "600",
                  }}
                  className="common-hover-btn"
                >
                  Apply Filters
                </Button>
              </Col>
            </Row>
          </div>
          {/* 🔹 TABLES */}
          <div style={{ marginTop: "20px" }}>
            {/* ROW 1 */}
            <Row className="g-3">
              <Col xl={12} lg={12} md={12}>
                <div
                  style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                  }}
                >
                  <div
                    style={{
                      backgroundColor:
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour4,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour11,
                      padding: "14px",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "18px",
                        margin: 0,
                        letterSpacing: "1px",
                        fontWeight: "600",
                      }}
                    >
                      SALE AMOUNT MONTHWISE
                    </h2>
                  </div>

                  <FASChart
                    data={
                      SalesDashboarddata?.Chart?.map((item) => ({
                        month: item?.monthname || item?.MonthName,
                        value: item?.NetAmount || 0,
                      })) || []
                    }
                    labelKey="month"
                    valueKey="value"
                  />
                </div>
              </Col>
            </Row>

            <Row className="g-3 mt-3">
              <Col xs={12}>
                {/* ✅ BUTTONS */}
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "12px" }}
                >
                  {["Production", "Item", "Party"].map((btn) => (
                    <button
                      key={btn}
                      onClick={() => setActiveTable(btn)}
                      style={{
                        flex: 1,
                        height: "52px",
                        borderRadius: "14px",
                        cursor: "pointer",
                        fontWeight: "600",
                        border: `2px solid ${isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                          }`,
                        background:
                          activeTable === btn
                            ? isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour10
                            : isdark === "light"
                              ? iscolour?.Colour1
                              : iscolourDark?.Colour4,
                        color:
                          activeTable === btn
                            ? isdark === "light"
                              ? iscolour?.Colour1
                              : iscolourDark?.Colour1
                            : isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour11,
                      }}
                    >
                      {btn}
                    </button>
                  ))}
                </div>

                {/* ✅ HEADING */}
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour4,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    padding: "14px",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    {activeTable === "Production"
                      ? "PRODUCTION GROUP SALE AMOUNT"
                      : activeTable === "Item"
                        ? "ITEMWISE SALE AMOUNT"
                        : "PARTYWISE SALE AMOUNT"}
                  </h2>
                </div>

                {/* ✅ TABLE SWITCH */}
                <div
                  style={{
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                  }}
                >
                  <FASTable
                    data={
                      activeTable === "Production"
                        ? ProductionGroupSaleRow()
                        : activeTable === "Item"
                          ? ItemWiseSaleAmountRow()
                          : PartyWiseSaleRow()
                    }
                    columns={
                      activeTable === "Production"
                        ? ProductionGroupSaleColumns
                        : activeTable === "Item"
                          ? itemWiseColumns
                          : partyWiseColumns
                    }
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};
